/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesCostTrendWidgetConfiguration extends models.BaseCostTrendWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("KubernetesCostTrendWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return KubernetesCostTrendWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<KubernetesCostTrendWidgetConfiguration>): KubernetesCostTrendWidgetConfiguration {
        let obj = Object.assign(new KubernetesCostTrendWidgetConfiguration(), model);
        KubernetesCostTrendWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesCostTrendWidgetConfiguration>): KubernetesCostTrendWidgetConfiguration {
        if (!model) return null;
        return KubernetesCostTrendWidgetConfiguration.newInstance(<KubernetesCostTrendWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesCostTrendWidgetConfiguration) {
        if (!obj) return;

        models.KubernetesCostTrendWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesCostTrendWidgetConfiguration): boolean {
        if (models.BaseCostTrendWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, KubernetesCostTrendWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Platform this widget reports cost data for
     */
    platform: models.Platforms;

    primaryMetric: string;

    visibleMetrics: Array<string>;

}
